import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
export var ItemFragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ItemFragment on Item {\n    id\n    partNumber\n    title\n    description\n    reference\n    available\n    type\n  }\n"])));
export default ItemFragment;